<div class="{{messageKind}}">
  <div message-content>
    <span>{{message.text}}</span>
  </div>

  <div extras (click)="markAsRead()">
    <mat-icon>{{ matIconName }}</mat-icon>
    <mat-spinner *ngIf="isLoading" [diameter]="20"></mat-spinner>
    <button *ngIf="message.isNotification" [class.invisible]="isLoading || !message.isNotification" mat-stroked-button class="mark-as-read">
      {{ 'message.markAsRead' | translate }}
    </button>
  </div>
</div>
